import PropTypes from 'prop-types';
import {emailSendingTypes} from 'helpers/constants';
import React from 'react';
import events from 'lib/events';
import email from 'api/email';
import EmailSelect from '../forms/emailSelect';
import EditableTextArea from '../forms/editableTextArea';
import FooterButton from 'components/layout/footerButton';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class EmailModal extends React.Component {
  static defaultProps = {
    subject: '',
    contacts: [],
    directEmail: false,
    analysisEmail: false,
    seasonUsageEmail: false,
    caslRestricted: false,
  };

  static propTypes = {
    analysisBody: PropTypes.any,
    analysisID: PropTypes.number,
    baseMessage: PropTypes.string,
    baseMessageFr: PropTypes.string,
    contacts: PropTypes.array,
    customerID: PropTypes.number,
    dealerName: PropTypes.string,
    poolID: PropTypes.number,
    subject: PropTypes.string,
    title: PropTypes.any,
    type: PropTypes.number,
    target: PropTypes.number,
    reportURL: PropTypes.string,
    intl: intlShape.isRequired,
    bottomLocation: PropTypes.string,
    caslRestricted: PropTypes.bool,
    shelfArticle: PropTypes.object,
  };

  state = {
    message: '',
    visible: false,
    emailDisabled: true,
    messages: [],
    emailList: [],
    sending: false,
  };

  closeModal = () => {
    this.setState({message: '', visible: false});
  };

  emailApiCall = () => {
    let emails = this.emails.getEmailList();
    let message = this.state.message;

    if (this.props.type === emailSendingTypes.analysis) {
      return email.analysis(emails, this.props.analysisID, this.props.analysisBody, message, this.props.reportURL);
    }
    if (this.props.type === emailSendingTypes.seasonsUsage) {
      return email.seasonUsage(emails, this.props.subject, message, this.props.reportURL);
    }

    if (this.props.type === emailSendingTypes.encyclopedia) {
      return email.encyclopedia(emails, this.props.shelfArticle, message);
    }

    if (this.props.type === emailSendingTypes.reportHistory) {
      let base = `
      <div>
        <p>[name],</p>
        ${this.props.baseMessage}
      </div>`;

      return email.history(emails, base, message, this.props.customerID, this.props.baseMessageFr);
    }
    return email.direct(emails, this.props.subject, this.props.baseMessage, message, this.props.customerID, this.props.baseMessageFr);
  };

  emailSelectChange = values => {
    const tmpMsg = [];
    const tmpEmails = [];

    this.setState({emailDisabled: values.length === 0});
    if (values.length !== 0) {
      values.forEach(val => {
        if (this.props.baseMessage) {
          tmpMsg.push(this.props.baseMessage
            .replace(/firstName lastName/g, val.firstName && val.firstName ? ' ' + val.firstName + ' ' + val.lastName : ''));
        }
        tmpEmails.push(val.email);
      });
    }
    this.setState({messages: tmpMsg, emailList: tmpEmails});
  };

  sendEmail = () => {
    if (this.sending) {
      return;
    }

    let emailList = this.emails.getEmailList();
    let {formatMessage} = this.props.intl;

    if (!emailList) {
      return;
    }

    this.sending = true;
    this.emailApiCall()
      .then(() => {
        events.publish('success.user', {
          message: <FormattedMessage id='email.modal.success.message'
                                     values={{
                                       title: this.props.title,
                                       users: <span className='blue'>{emailList}</span>,
                                     }}/>,
        });
        this.closeModal();
        this.sending = false;
      })
      .catch(err => {
        events.publish('error.user', err);
        this.sending = false;
      });
  };

  sending = false; // Storing this not in the state because it wasn't updating fast enough to block double sending

  toggleEmailReport = () => {
    this.setState({visible: !this.state.visible});
  };

  updateMessage = e => {
    this.setState({message: e.value});
  };

  render() {
    const {formatMessage} = this.props.intl;
    const {bottomLocation} = this.props;

    if (!this.state.visible) {
      return <FooterButton label={formatMessage({id: 'general.email'})}
                           icon='bl bl-2x bl-email'
                           onClick={this.toggleEmailReport}/>;
    }

    return <div>
      <span className='footer-item footer-edit-options'>
        <i className='footer-item-icon bl bl-2x bl-email'/>
        <FormattedMessage id="general.email"/>
          &nbsp;
        <button type='button'
                  className='btn btn-default'
                  onClick={this.toggleEmailReport}>
          <FormattedMessage id="general.cancel"/>
        </button>
        <button type='button'
                  className='btn btn-primary'
                  onClick={this.sendEmail}
                  disabled={this.state.emailDisabled}>
          <FormattedMessage id="general.send"/>
        </button>
      </span>
      <div className='container email-modal' style={bottomLocation ? {'bottom': '130px'} : null}>
        <div className='email-modal-border'>
          <div className='email-modal-header'>
            <h3><FormattedMessage id="general.email"/> {this.props.title}</h3>
          </div>
          <div className='email-modal-content'>
            <EmailSelect ref={r => this.emails = r}
                         customerID={this.props.customerID}
                         onUpdate={this.emailSelectChange}
                         formatMessage={this.props.intl.formatMessage}
                         disableEdit={this.props.caslRestricted}
                         caslRestricted={this.props.caslRestricted}
            />
            <div className='form-group'>
              <label><FormattedMessage id="general.message"/>
                <span className='dim n'>(<FormattedMessage id="general.optional"/>):</span></label>
              <EditableTextArea editMode={true}
                                dataKey='message'
                                placeholder={this.props.intl.formatMessage({id: 'email.message.placeholder'})}
                                value={this.state.message}
                                onChange={this.updateMessage}/>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(EmailModal);
